import { Plus } from 'lucide-react'

interface DeviceHeaderProps {
  onAddDevice: () => void
  canCreateDevices: boolean
}

export const DeviceHeader = ({ onAddDevice, canCreateDevices }: DeviceHeaderProps) => {
  return (
    <div className="flex items-center justify-between">
      <h1 className="text-2xl font-bold text-gray-900">Device Management</h1>
      {canCreateDevices && (
        <button
          onClick={onAddDevice}
          className="inline-flex items-center px-4 py-3 bg-white text-black border border-gray-200 text-sm font-medium rounded-full hover:bg-gray-800 hover:text-white transition-colors"
        >
          <Plus className="w-4 h-4 mr-2" />
          Add Device
        </button>
      )}
    </div>
  )
}
